import { AfterViewInit, ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { BehaviorSubject, Observable, timer } from 'rxjs';
import { take } from 'rxjs/operators';
import { HubBrief, HubListFacade, HubListSearchCriteria, LoadingFacade } from '../../../../../store';
import { ListQueryParam, ListRange, ListServerPagination, ListServerPaginationStateModel } from '../../../../../common';
import { ButtonAction, ButtonType } from '../../../../action-button';
import { FilterSearch, FilterSettings } from '../../../../list-filter';
import { TranslateService } from '@ngx-translate/core';
import { HubSelectionItem } from '../../../../../container-components/hubs-selection/models';

@Component({
  selector: 'lib-hubs-filter-dialog',
  templateUrl: './hubs-filter-dialog.component.html',
  styleUrls: ['./hubs-filter-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HubsFilterDialogComponent
  extends ListServerPagination<HubBrief>
  implements OnInit, AfterViewInit, OnDestroy
{
  @ViewChild(MatPaginator) paginator: MatPaginator;

  displayedColumns = ['select', 'name', 'ssccId'];
  listDto$: Observable<ListServerPaginationStateModel<HubBrief>>;
  filterConfig: FilterSettings;
  searchCriteriaValue: HubListSearchCriteria = new HubListSearchCriteria();
  buttonAction = ButtonAction;
  buttonType = ButtonType;
  selectedRows = new HubBrief();
  hasValue$ = new BehaviorSubject<boolean>(false);

  constructor(
    translateService: TranslateService,
    public dialogRef: MatDialogRef<HubsFilterDialogComponent>,
    public hubListFacade: HubListFacade,
    public loadingFacade: LoadingFacade,
    @Inject(MAT_DIALOG_DATA) public data: HubSelectionItem[],
  ) {
    super(translateService);
    this.listDto$ = hubListFacade.listDto$;
  }

  ngOnInit(): void {
    this.initFiltersForm();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }

  ngOnDestroy(): void {
    this.hubListFacade.setInitialState();
  }

  fetchList(listRange: ListRange): void {
    timer(0)
      .pipe(take(1))
      .subscribe(() => {
        this.searchCriteriaValue = {
          ...this.searchCriteriaValue,
          ...listRange,
        };
        this.hubListFacade.loadListForDialog(new HubListSearchCriteria(this.searchCriteriaValue));
      });
  }

  fetchListBySearchCriteria(filterValue?: HubListSearchCriteria): void {
    if (filterValue) {
      this.searchCriteriaValue = {
        ...this.searchCriteriaValue,
        ...filterValue,
        page: 0,
      };
    } else {
      this.searchCriteriaValue = {
        ...this.searchCriteriaValue,
        page: 0,
      };
    }
    this.hubListFacade.loadListForDialog(new HubListSearchCriteria(this.searchCriteriaValue));
  }

  noHubsExist(): boolean {
    return !this.searchCriteriaValue[ListQueryParam.Filter] && this.dataSource && this.dataSource.data.length === 0;
  }

  confirm(): void {
    this.dialogRef.close(this.selectedRows);
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  toggle(row: HubBrief): void {
    this.selectedRows = row;
  }

  private initFiltersForm(): void {
    this.filterConfig = {
      items: [new FilterSearch({ name: ListQueryParam.Filter })],
    };
  }
}
